import Icon from "@expo/vector-icons/MaterialCommunityIcons";
import { useCallback, useState } from "react";
import { IconButton, Menu } from "react-native-paper";
import type { IconType } from "../../icon";
import { useAppTheme } from "../../useAppTheme";
import type { GetMessageActions } from "./types";

type Props = {
	messageActions: GetMessageActions;
	content?: string;
	showEmail?: boolean;
	align?:
		| "flex-start"
		| "flex-end"
		| "center"
		| "space-between"
		| "space-around"
		| "space-evenly"
		| undefined;
	runId?: string;
};

export const MessageActions = ({
	messageActions,
	align: _align = "flex-start",
	showEmail,
	content,
	runId,
}: Props) => {
	const theme = useAppTheme();
	const [visible, setVisible] = useState(false);

	const openMenu = useCallback(() => {
		setVisible(true);
	}, []);

	const closeMenu = () => {
		setVisible(false);
	};

	return (
		<Menu
			visible={visible}
			onDismiss={closeMenu}
			anchor={
				<IconButton
					icon="dots-vertical"
					size={18}
					iconColor={theme.colors.onPrimaryContainer}
					style={{ margin: 0 }}
					onPress={openMenu}
				/>
			}
		>
			{messageActions(showEmail, runId).map(
				({ icon, tooltip, handleOnPress }) => (
					<Menu.Item
						key={icon}
						leadingIcon={
							icon
								? (props) => (
										<Icon
											{...props}
											name={icon as IconType}
											color={theme.colors.onPrimaryContainer}
											size={18}
										/>
									)
								: undefined
						}
						title={tooltip}
						onPress={() => {
							handleOnPress(content);
							closeMenu();
						}}
					/>
				),
			)}
		</Menu>
	);
};
